<template>
  <div class="loadingDiv" :class="{ mask: mask }" :style="{ height: `${height}px` }" v-if="loading">
    <VueSimpleSpinner message="Loading..." />
  </div>
</template>

<script>
import VueSimpleSpinner from 'vue-simple-spinner';

export default {
  name: 'LoadingMask',
  components: {
    VueSimpleSpinner,
  },
  props: {
    loading: Boolean,
    height: {
      type: Number,
    },
    mask: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped>
.loadingDiv {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 8;
  transition: opacity 0.3s;
}
.mask {
  background-color: hsla(0, 0%, 100%, 0.9);
}
</style>
